import React, { ReactElement, useEffect, useState } from "react";

import ModuleAccess from "@/components/Layouts/ModuleAccess";
import DeviceUtilization from "@/components/modules/Box/deviceUtilization";
import ContentWrapper from "@/components/utils/ContentWrapper";
import { Loader } from "@/components/utils/Loader";
import { useAppSelector } from "@/lib/hooks";
import { useAgnosticUntaggedGetQuery } from "@/lib/services/endpoints/newAPI/agnostic";
import { useGetUtilitiesQuery } from "@/lib/services/endpoints/newAPI/utilities";
import { subDays } from "date-fns";
import Head from "next/head";

import DashboardLayout from "../../../components/Layouts/DashboardLayout";
import { NextPageWithLayout } from "../../../lib/types";

const EnergyPage: NextPageWithLayout = () => {
  const { client } = useAppSelector((state) => state.apiData.favourite);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const datesGetter = useAgnosticUntaggedGetQuery(
    {
      url: `client/${client}/module/sensor/lastActiveTime`,
    },
    { skip: !client }
  );

  const utilities = useGetUtilitiesQuery(
    {
      client,
      filters: { complete: "1" },
    },
    {
      skip: !client,
    }
  );

  useEffect(() => {
    const res = datesGetter?.data;
    setEndDate(null);

    if (res) {
      if (res.status == "success") {
        const ed = new Date(res?.time * 1000);
        ed.setUTCHours(0, 0, 0, 0);
        ed.setUTCDate(ed.getUTCDate() - 2);
        setStartDate(subDays(ed, 7));
        setEndDate(ed);
      }
    }
  }, [datesGetter, client]);

  return (
    <>
      <Head>
        <title>Modules | Box | Energy</title>
      </Head>

      {startDate && endDate ? (
        <ContentWrapper>
          <DeviceUtilization
            utilities={utilities.data?.data}
            includeDatatable={true}
            includeSummary={true}
            pickDates={true}
            initialFromDate={startDate}
            initialToDate={endDate}
          />
        </ContentWrapper>
      ) : (
        <Loader />
      )}
    </>
  );
};

EnergyPage.getLayout = function getLayout(page: ReactElement) {
  return (
    <ModuleAccess subSystem="Box">
      <DashboardLayout>{page}</DashboardLayout>
    </ModuleAccess>
  );
};

export default EnergyPage;
